const translations = {
    add: 'Add',
    dismiss: 'Dismiss',
    reticleAddPointCircle:
        'Move the map under the reticle to the circle’s center and add a point. Then, add a point on the circumference.',
    reticleAddPointPolygon:
        'Move the map under the reticle and add points to form a flight boundary.',
    touchAddPointCircle:
        'Tap to place the center point of the flight boundary circle. Then, set the radius',
    touchAddPointPolygon: 'Tap on the map to add points to form a flight boundary.'
};

export default translations;
